import React from 'react';
import JanusComponent from './JanusComponent';
import JanusPlayer from './JanusPlayer';
import JanusPublisher from './JanusPublish';
import JanusVideoRoom from './JanusVideoRoom';
import './index.css';
import Janus from './utils/janus';
import { CALL_URL } from '../../circulusConfig';
import { setGroup } from '../../pibo';

const VideoApp = ({ caller, callee }) => {
  const opaqueId = `videocalltest-${Janus.randomString(12)}`;
  setGroup([callee]);

  return (
    <div className="VideoApp">
      <JanusComponent server={CALL_URL}>
        <JanusVideoRoom>
          <JanusPublisher {...{ opaqueId, caller, callee }}>
            <JanusPlayer readyText="Something" />
          </JanusPublisher>
        </JanusVideoRoom>
      </JanusComponent>
    </div>
  );
};

export default VideoApp;
